import { useTranslation } from "react-i18next";
import Helmet from "react-helmet";
import ImageHeader from "../../../../components/image-header/image-header";
import liveAnimalsImg from "../../../../assets/imgs/services/nationals/live-animals.jpg";
import Accordion from "../../../../components/acordion/accordion";
import { useEffect, useState } from "react";
import axios from "axios";
import navBarEn from "../../../../translations/en/navbar.json";
import navBarEs from "../../../../translations/es/navbar.json";

import liveanimals1Icon from "../../../../assets/imgs/services/nationals/liveanimals-icons/liveanimals1.svg"
import liveanimals2Icon from "../../../../assets/imgs/services/nationals/liveanimals-icons/liveanimals2.svg"
import liveanimals3Icon from "../../../../assets/imgs/services/nationals/liveanimals-icons/liveanimals3.svg"
import liveanimals4Icon from "../../../../assets/imgs/services/nationals/liveanimals-icons/liveanimals4.svg"
import liveanimals5Icon from "../../../../assets/imgs/services/nationals/liveanimals-icons/liveanimals5.svg"
import liveanimals6Icon from "../../../../assets/imgs/services/nationals/liveanimals-icons/liveanimals6.svg"
import NationalDescription from "../../../../components/national-description/national-description";

function LiveAnimals() {
  const [tLiveAnimals] = useTranslation("liveAnimalsPage");
  const [tSMetaData] = useTranslation("metaData");
  const idLiveAnimals = "4c7bc6a5-2883-403f-9cf4-b1312507e7f3";
  const [textDescription, setTextDescription] = useState("");
  const [accordion2, setAccordion2] = useState("");
  const [openAccordion, setOpenAccordion] = useState(null);

  sessionStorage.setItem(
    "routeEs",
    `/${navBarEs["category-services"].services}/${
      Object.keys(navBarEs["products-submenu"])[0]
    }/${Object.keys(navBarEs["products-nacionales-submenu"])[6]}`
  );

  sessionStorage.setItem(
    "routeEn",
    `/${navBarEn["category-services"].services}/${
      Object.keys(navBarEn["products-submenu"])[0]
    }/${Object.keys(navBarEn["products-nationals-submenu"])[6]}`
  );

  useEffect(() => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    axios
      .get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idLiveAnimals}`)
      .then((response) => {
        if (currentLng === "es") {
          setTextDescription(
            response.data.textWeb.text_es["01-descripción"].content
          );
          setAccordion2(
            response.data.textWeb.text_es[
              "03-Documentación, Aceptación y Recolección"
            ].content
          );
        } else {
          setTextDescription(
            response.data.textWeb.text_us["01-description"].content
          );
          setAccordion2(
            response.data.textWeb.text_us["03-Check-in, Acceptance and Pickup"]
              .content
          );
        }
      })
      .catch((error) => {
        console.error(error);
      });
  }, []);

  return (
    <>
      <Helmet>
        <title>{tSMetaData("animalesVivos.title")}</title>
        <meta
          name="description"
          content={tSMetaData("animalesVivos.description")}
        />
      </Helmet>
      {/* <ImageHeader
        section={tLiveAnimals("header.section")}
        title={tLiveAnimals("header.title")}
        description={
          textDescription
            ? JSON.parse(textDescription)
            : JSON.parse(tLiveAnimals("description.content"))
        }
        quoteBtn={tLiveAnimals("header.quote-btn")}
        quoteProductID="btnQuoteAnimals"
        contactSales={tLiveAnimals("header.contact-sales")}
        contactProductID="btnContactAnimals"
        imgBackground={liveAnimalsImg}
      /> */}
      <ImageHeader
        imgBackground={liveAnimalsImg}
      />
      {/* <Accordion
        title={tLiveAnimals("accordion-1.title")}
        content={JSON.parse(tLiveAnimals("accordion-1.content"))}
      />
      <div className="divider"></div>
      <Accordion
        title={tLiveAnimals("accordion-2.title")}
        content={
          accordion2
            ? JSON.parse(accordion2)
            : JSON.parse(tLiveAnimals("accordion-2.content"))
        }
      />
      <div className="divider"></div>
      <Accordion
        title={tLiveAnimals("accordion-3.title")}
        content={JSON.parse(tLiveAnimals("accordion-3.content"))}
      />
      <div className="divider"></div> */}
      <div className="info-national-content">
        <NationalDescription
          title={tLiveAnimals("header.title")} 
          description={
            textDescription
            ? JSON.parse(textDescription) : ""
          }
          quoteBtn={tLiveAnimals("header.quote-btn")}
          quoteProductID="btnQuoteGold"
          contactSales={tLiveAnimals("header.contact-sales")}
          contactProductID="btnContactGold"
        />
        <div className="accordion-content-main">
          <div className="title">
            <h3>{tLiveAnimals("header.prepare-charge")}</h3>
          </div>

          <div className="accordion-padd">
            <Accordion
              id={1}
              isOpen={openAccordion === 1}
              onToggle={setOpenAccordion}
              title={tLiveAnimals("accordion-1.title")}
              content={
                tLiveAnimals("accordion-1.content")
                  ? JSON.parse(tLiveAnimals("accordion-1.content")) : "{}"
              }
            />

            <Accordion
              id={2}
              isOpen={openAccordion === 2}
              onToggle={setOpenAccordion}
              title={tLiveAnimals("accordion-2.title")}
              content={
                accordion2
                  ? JSON.parse(accordion2) : "{}"
              }
            />

            <Accordion
              id={3}
              isOpen={openAccordion === 3}
              onToggle={setOpenAccordion}
              title={tLiveAnimals("accordion-3.title")}
              content={
                tLiveAnimals("accordion-3.content")
                  ? JSON.parse(tLiveAnimals("accordion-3.content")) : "{}"
              }
            />
          </div>
          
        </div>
      </div>

      {/* ===================================================== */}

      <div className="more-info-content">
        <div className="more-info-box">
          <h5>{tLiveAnimals("non-applicable-charges.title")}</h5>

          <div className="icons">
            <div className="item">
              <div className="icon"><img src={liveanimals1Icon} /></div>
              <p>{tLiveAnimals("non-applicable-charges.item1")}</p>
            </div>

            <div className="item">
              <div className="icon"><img src={liveanimals2Icon} /></div>
              <p>{tLiveAnimals("non-applicable-charges.item2")}</p>
            </div>

            <div className="item">
              <div className="icon"><img src={liveanimals3Icon} /></div>
              <p>{tLiveAnimals("non-applicable-charges.item3")}</p>
            </div>

          </div>
        </div>

        <div className="more-info-box">
          <h5>{tLiveAnimals("additional-conditions.title")}</h5>

          <div className="icons">
            <div className="item">
              <div className="icon"><img src={liveanimals4Icon} /></div>
              <p>{tLiveAnimals("additional-conditions.item1")}</p>
            </div>

            <div className="item">
              <div className="icon"><img src={liveanimals5Icon} /></div>
              <p>{tLiveAnimals("additional-conditions.item2")}</p>
            </div>

            <div className="item">
              <div className="icon"><img src={liveanimals6Icon} /></div>
              <p>{tLiveAnimals("additional-conditions.item3")}</p>
            </div>
          </div>

        </div>
      </div>
    </>
  );
}

export default LiveAnimals;
